import React from 'react'
import './Product.less'
import { goIndex } from '@/assets/js/utils'

function Product ({ buriedPointEvent, data: { sublist = [], id, position, trackId, style = {} }, templateType }) {
    if (!style) style = { paddingTop: 0 }
    const isindex = templateType === 'TPL_INDEX_MIXED_PRODUCT_LIST'
    const name = templateType === 'TPL_INDEX_MIXED_PRODUCT_LIST' ? 'index' : 'invest'
    return (
        <div style={{ paddingTop: `${style.paddingTop / 75}rem` }}>
            {sublist.map((item, index) => (
                <div
                    className="product statistics-dom"
                    key={item.id}
                    onClick={() => {
                        buriedPointEvent({
                            button_name: `${trackId}-${item.title}`,
                            button_id: `${item.id}`,
                            button_order: `${index + 1}`,
                            area_order: position,
                            button_area: `${position}-${trackId}`
                        })
                        goIndex(item.url, trackId, item.keyword, item)
                    }}
                >
                    <div className="product-left">
                        <div className="left-top">
                            <div className='rate-num'>{item.rate}</div>
                            <div className='rate-flag'>%</div>
                            {item.rateYearPlus && <div className="rate-flag">+{item.rateYearPlus}%</div>}
                        </div>
                        <div className="left-bottom">{item.rateName}</div>
                    </div>
                    <div className="product-right">
                        <div className="right-top">
                            <div className={`${name}-trait trait`} style={{
                                maxWidth: (name === 'index' || (name === 'invest' && !item.productMark)) ? `${350 / 75}rem` : `${200 / 75}rem`
                            }}>{item.productTrait}</div>
                            {item.productMark && <div className="productMark">{item.productMark}</div>}
                        </div>
                        <div className="right-bottom">
                            <span className={`${name}-lineName`}>{item.businessLineName}</span>
                            {!isindex && <span className="invest-line">|</span>}
                            <span className="pro-title">{item.title}</span>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default Product
